import { DASHBOARD_PACING_STATUS_LABELS, type DashboardPacingRow } from "./dashboardPacing";
import type { MemberDashboardPacingMetric } from "../queries";

export type DashboardMemberPacingRows = {
  pdr: DashboardPacingRow[];
  dues: DashboardPacingRow[];
};

export function toDashboardMemberPacingRows(metrics: MemberDashboardPacingMetric[]): DashboardMemberPacingRows {
  return metrics.reduce<DashboardMemberPacingRows>(
    (rows, metric) => {
      const row: DashboardPacingRow = {
        id: `member-${metric.key.toLowerCase()}`,
        label: metric.label,
        percent: metric.percent,
        completed: metric.completed,
        total: metric.total,
        status: metric.status,
        statusLabel: DASHBOARD_PACING_STATUS_LABELS[metric.status],
        detailLabel: "completed"
      };

      if (metric.key === "PDR") {
        rows.pdr = [row];
      } else {
        rows.dues = [row];
      }

      return rows;
    },
    { pdr: [], dues: [] }
  );
}
